<template>
  <div class='app-main'>  
    <navbar  />
    <div class="mainCon">
    <breadcrumb  class="breadcrumb" />
    <!-- <SpeakingSidebar v-if="sidebar_active"/> -->    
    <keep-alive>
    <router-view v-if="$route.meta.keepAlive" :key="key"></router-view>
</keep-alive>
<router-view v-if="!$route.meta.keepAlive" :key="key"></router-view>
   
    
    </div>    
  </div>
</template>

<script>
import Breadcrumb from '@/modules/Breadcrumb'
import Navbar from '@/modules/Navbar'
// import SpeakingSidebar from '@/layout/SpeakingSidebar'
export default {
  name: 'speakMeetingHome',
  data(){
     return{
       sidebar_active:''
     }
  },
   components: {
    Breadcrumb,
    Navbar
    // SpeakingSidebar
   
  },
  computed: {
    key() {
      return this.$route.fullPath
    }
  },
  mounted(){
   
    this.sidebar_active=window.sessionStorage.getItem("sidebar_active");
   
  }
  //  watch: {
  //   $route: "setSidebar_active"
  // }
}
</script>

<style scoped>
.app-main {
  /*50 = navbar  */
  /* min-height: 100%; */
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: #F5F6FA;
}
.breadcrumb{
  padding-top: 20px;
}
.show{
  display:block
}
.hidden{
  display: none
}
.app-main >>>  .el-icon-date:before, .app-main >>> .el-icon-arrow-up:before, .app-main >>> .el-icon-arrow-down:before, .app-main >>> .el-icon-location:before {
  color: rgba(211,189,142,1);
}
.app-main >>>  .el-row .el-col{
  font-weight:400;
  color:rgba(51,51,51,1);
}
.mainCon{
  height: calc(100% - 80px);
  overflow: auto;
}
.mainCon::-webkit-scrollbar{width:0px;}
</style>




// WEBPACK FOOTER //
// src/pages/speakMeeting/speakMeetingHome.vue